import { AuswahlAnzeigeAllgemein } from "./auswahl-anzeige-allgemein.model";
import { ErgebnisQuelleSonstige } from "./ergebnis-quelle-sonstige.model";

export class AuswahlAnzeigeSonstigeQuelle extends AuswahlAnzeigeAllgemein 
{

constructor(ergebnisQuelleSonstige: ErgebnisQuelleSonstige)
{
    super(ergebnisQuelleSonstige);
    
 
}

}